
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M5.362 8.44l3-3.027L3.618.626A6.32 6.32 0 0110.86 1.88c1.958 1.977 2.373 4.923 1.243 7.31L16 13.126V16h-3.15l-3.745-3.78a6.32 6.32 0 01-7.242-1.256C-.095 8.987-.51 6.04.62 3.654L5.362 8.44z"}})])
          )
        }
      }
    